import { reportConstant } from '../constants';

export const report = (state = {
    data: [],
}, action) => {
    switch (action.type) {
        case reportConstant.REPORT_DATA:
            return {
                ...state,
                data: action.payload.report
            }
        case reportConstant.REPORT_SELECTED_FILTERS:
            return {
                ...state,
                filter: action.payload
            }
        default:
            return state
    }
}